import React from 'react';
import Button from '../Button/Button';
import Text from '../Text/Text';
import './InfoPage.css';

const InfoCity = (props) => {

    return (
        <div>
            <img src={props.bgSrc} className='smallBg' alt=' ' />
            <Text className='City' value={props.text.name} />
            <Text className='Text1' value={props.text.text1} />
            <Text className='Text2' value={props.text.text2} />
            <img className='GerbInfo' src={props.src} alt='' />
            <Button className='Continue' onClick={() => props.onClick('next')} value={props.textGame.Continue[props.lang]} />
            <Button className='GamePrev' onClick={() => props.onClick('prev')} hidden={(props.step === 0) ? true : false} /> 
        </div>
    );
    };

export default InfoCity;
